// Compatibility shim (Wave 1 · P1). The console interceptor now lives in
// `@heidi/runtime/logger`. Burned down by the deferred consumer codemod.
export { interceptConsoleMethods, originalConsoleMethods } from '@heidi/runtime/logger';
